<template>
  <div class="floor-input-wrapper">
    <div class="floor-input-card">
      <h3 class="floor-input-title">Building Details</h3>
      <p class="floor-input-subtitle">How many floors does your building have?</p>

      <div class="floor-input-field">
        <label class="floor-input-label">Number of Floors</label>
        <div class="floor-input-stepper">
          <button
            class="stepper-btn"
            :disabled="floorValue <= 1"
            @click="decrement"
          >
            &minus;
          </button>
          <input
            type="number"
            v-model.number="floorValue"
            class="stepper-value"
            min="1"
            max="20"
            @input="validate"
            @keydown="preventSpecialChars"
          />
          <button
            class="stepper-btn"
            :disabled="floorValue >= 20"
            @click="increment"
          >
            &#43;
          </button>
        </div>
        <p v-if="error" class="floor-input-error">Please enter a value between 1 and 20.</p>
      </div>

      <button
        class="floor-input-cta"
        :disabled="!isValid"
        @click="proceed"
      >
        Continue to Draw Roof
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FloorInput',
  emits: ['submit'],

  data() {
    return {
      floorValue: 1,
      error: false,
    };
  },

  props: {
    initialValue: {
      type: Number,
      default: 1,
    },
  },

  mounted() {
    if (this.initialValue && this.initialValue >= 1 && this.initialValue <= 20) {
      this.floorValue = this.initialValue;
    }
  },

  computed: {
    isValid() {
      const v = parseInt(this.floorValue, 10);
      return !isNaN(v) && v >= 1 && v <= 20;
    },
  },

  methods: {
    increment() {
      if (this.floorValue < 20) {
        this.floorValue++;
        this.error = false;
      }
    },
    decrement() {
      if (this.floorValue > 1) {
        this.floorValue--;
        this.error = false;
      }
    },
    validate() {
      const v = parseInt(this.floorValue, 10);
      this.error = isNaN(v) || v < 1 || v > 20;
    },
    preventSpecialChars(e) {
      if (['e', 'E', '+', '-', '.'].includes(e.key)) {
        e.preventDefault();
      }
    },
    proceed() {
      if (!this.isValid) return;
      this.$emit('submit', parseInt(this.floorValue, 10));
    },
  },
};
</script>

<style scoped>
.floor-input-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  padding: 0 16px 24px;
  pointer-events: none;
}

.floor-input-card {
  pointer-events: auto;
  background: #fff;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.12);
  padding: 24px 20px 20px;
  width: 100%;
  max-width: 420px;
}

.floor-input-title {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 600;
  color: #1a1a2e;
}

.floor-input-subtitle {
  margin: 0 0 20px;
  font-size: 14px;
  color: #6b7280;
}

.floor-input-field {
  margin-bottom: 20px;
}

.floor-input-label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
}

.floor-input-stepper {
  display: flex;
  align-items: center;
  gap: 0;
  border: 1.5px solid #d1d5db;
  border-radius: 10px;
  overflow: hidden;
}

.stepper-btn {
  width: 48px;
  height: 48px;
  border: none;
  background: #f3f4f6;
  font-size: 20px;
  color: #374151;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
  -webkit-tap-highlight-color: transparent;
}

.stepper-btn:active {
  background: #e5e7eb;
}

.stepper-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.stepper-value {
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  border: none;
  outline: none;
  color: #1a1a2e;
  background: transparent;
  appearance: textfield;
  -moz-appearance: textfield;
}

.stepper-value::-webkit-inner-spin-button,
.stepper-value::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.floor-input-error {
  margin: 6px 0 0;
  font-size: 12px;
  color: #ef4444;
}

.floor-input-cta {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 10px;
  background: #006eaf;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s;
  -webkit-tap-highlight-color: transparent;
}

.floor-input-cta:active {
  opacity: 0.85;
}

.floor-input-cta:disabled {
  background: #d1d5db;
  cursor: not-allowed;
}
</style>
